/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { DescargaService } from './../_services/descargas.service';
import { DescargaRespuesta } from './../_models/descargas';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-biblioteca',
  templateUrl: './biblioteca.component.html',
  styleUrls: ['./biblioteca.component.css']
})
export class BibliotecaComponent implements OnInit {

  respuesta: DescargaRespuesta;

  constructor(private service: DescargaService) {
    this.respuesta = new DescargaRespuesta();
  }

  ngOnInit() {
    this.service.getAll('files-biblioteca').subscribe(
      datos => {
        this.respuesta = datos;
      }
    );
  }

}
